
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
	import LogisticsSelect from '@/views/logistics/components/select.vue';
  import {
    freightSettlementTemplatefreightSettlementTemplateSave,
    freightSettlementTemplatefreightSettlementTemplateInfo
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
      LogisticsSelect
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:false}) show:boolean
    @Prop({default:()=>{return {}}}) msg:any
    private diaShow = false
    private form:any = {
      Id:'',
      TemplateName:'',
      FreightSettlementType:1,
      DetailList:[],
      UseProductList:[],
    }
    private areatype = 1
    private isShowDialog = false
    private selectArea:any = []
    private disableDate:any = []
    private loading = false
    @Watch('show')
    private watchShow(val){
      this.diaShow = val
      if(val){
        this.form.Id = this.msg.Id
        // console.log(this.form,11)
        if(this.msg.Id){
          this.getInfo()
        }
      }
    }



    private async getInfo(){
      try{
        this.loading = true
        let res = await freightSettlementTemplatefreightSettlementTemplateInfo({
          Id:this.msg.Id,
          ProductId:this.msg.ProductId
        })
        if(res.IsSuccess){
          this.form = res.Result
        }
      }finally{
        this.loading = false
      }
    }
    private async confirm(){
      if(!this.test()) return
      try{
        this.loading = true
        let res:any = await freightSettlementTemplatefreightSettlementTemplateSave({
          ...this.form,
          ProductId:this.msg.ProductId,
          IsScheduleProduct:true
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$emit('confirm',{
            ...this.form,
            Id:res.Result.Id
          })
          this.close()
        }
      }finally{
        this.loading = false
      }
    }
    private test(){
      let two = /^\d+(\.\d{1,2})?$/
      let form = JSON.parse(JSON.stringify(this.form))
      if(!form.TemplateName){
        this.$message.error('请输入模板名称')
        return false
      }
      if(!form.DetailList||!form.DetailList.length){
        this.$message.error('请设置区域运费规则')
        return false
      }
      for(let item of form.DetailList){
        if(form.FreightSettlementType==1){
          if(!item.FirstCountToNumber&&String(item.FirstCountToNumber)!=='0'
          ||!item.ContinueMoneyToNumber&&String(item.ContinueMoneyToNumber)!=='0'
          ||!item.ContinueCountToNumber&&String(item.ContinueCountToNumber)!=='0'
          ||!item.FirstMoneyToNumber&&String(item.FirstMoneyToNumber)!=='0'){
            this.$message.error('物流价格或件数不能为空')
            return false
          }
          if(
            item.ContinueMoneyToNumber<0||item.ContinueMoneyToNumber>1000000||!two.test(item.ContinueMoneyToNumber)||
            item.FirstMoneyToNumber<0||item.FirstMoneyToNumber>1000000||!two.test(item.FirstMoneyToNumber)
            )
            {
              this.$message.error('运费金额最大支持1000000')
              return false
            }
        }else{
          if(!item.FirstMoneyToNumber&&String(item.FirstMoneyToNumber)!=='0'){
            this.$message.error('请完善区域运费规则')
            return false
          }
          if(item.FirstMoneyToNumber<0||item.FirstMoneyToNumber>1000000||!two.test(item.FirstMoneyToNumber)){
            this.$message.error('运费金额最大支持1000000')
            return false
          }
        }
      }

      return true
    }
    private selectConfirm(e){
      if(!e.list||!e.list.length){
        this.$message.error('请选择配送区域')
        this.isShowDialog  =true
        return
      }
      // console.log(e)
      if(this.areatype<0){
        this.form.DetailList.push({
          AreaNames:e.list.map(v=>{
            return v.join('-')
          }),
          Id:0,
          FirstCountToNumber:'',
          FirstMoneyToNumber:'',
          ContinueCountToNumber:'',
          ContinueMoneyToNumber:'',
        })
      }else{
        this.form.DetailList[this.areatype].AreaNames = e.list.map(v=>{
          return v.join('-')
        })
      }
    }
    private delrow(e){
      this.form.DetailList.splice(e,1)
    }
    private pushDispensingArea(type,row?:any){
      this.areatype = type
      if(row.AreaNames&&row.AreaNames.length){
        this.selectArea = JSON.parse(JSON.stringify(row.AreaNames.map(x=>{
          return x.split('-')
        })))
      }else{
        this.selectArea = []
      }
      this.disableDate = JSON.parse(JSON.stringify(this.form.DetailList)).map(v=>{
        return v.AreaNames.map(x=>{
          return x.split('-')
        })
      }).flat().filter(v=>{
        let ishave = this.selectArea.some(m=>{
          let v0 = v[0]&&m[0]==v[0]
          let v1 = true
          if(v[1]){
            v1 = m[1]&&m[1]==v[1]
          }
          return v0&&v1
        })
        return !ishave
      })
      this.isShowDialog = true
    }
    private close(){
      this.$emit('close',false)
      this.form = {
        Id:'',
        TemplateName:'',
        FreightSettlementType:1,
        DetailList:[],
        UseProductList:[],
      }
    }
  }
